module.exports = __webpack_public_path__ + "img/enterprise-web.3426d5ed.png";